var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full relative h-10 text-grey-600 border border-solid border-grey-200 rounded-lg bg-white"},[_c('input',{ref:"input",staticClass:"w-full h-full outline-none rounded-lg px-4",attrs:{"type":"password","placeholder":_vm.placeholder},domProps:{"value":_vm.value},on:{"keyup":_vm.keyup,"keydown":_vm.keydown}})])
}
var staticRenderFns = []

export { render, staticRenderFns }